<template>
  <div class="promotion-end" :style="backgroundColorStyle">
    <div class="prompt">{{prompt}}</div>
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import { alert } from '../../utils/common'

export default {
  name: 'PromotionPrompt',
  i18n,
  props: {
    background: '',
    prompt: '',
    alert: '',
    alertCallback: {
      type: Function,
      required: true
    }
  },
  mounted () {
    if (this.alert.length > 0) {
      setTimeout(() => {
        alert(this.alert).then(_ => {
          this.alertCallback && this.alertCallback()
        })
      }, 200)
    }
  },
  data () {
    return {
    }
  },
  computed: {
    backgroundColorStyle () {
      let color = this.background === '' ? '#ffffff' : this.background
      return `background: ${color};`
    }
  }
}
</script>

<style lang="postcss">
.promotion-end {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: 500;
  background-color: #ffffff;
  color: #6ca2ff;
}
</style>
